module.exports = __webpack_public_path__ + "static/media/mvpf.3f1ea366.png";